export const CREATE_MENU = 'CREATE_MENU';
export const DELETE_MENU = 'DELETE_MENU';
export const GET_MENU = 'GET_MENU';
export const GET_MENU_DONE = 'GET_MENU_DONE';
export const GET_GROUP_BUYINGS_MENU = 'GET_GROUP_BUYINGS_MENU';
export const GET_GROUP_BUYINGS_MENU_LIMITS = 'GET_GROUP_BUYINGS_MENU_LIMITS';
export const IS_CREATING_MENU = 'IS_CREATING_MENU';
export const IS_DELETING_MENU = 'IS_DELETING_MENU';
export const IS_GETTING_MENU = 'IS_GETTING_MENU';
export const IS_UPDATING_MENU = 'IS_UPDATING_MENU';
export const SET_MENU = 'SET_MENU';
export const SET_MENU_DONE = 'SET_MENU_DONE';
export const UPDATE_MENU = 'UPDATE_MENU';
export const UPDATE_GROUP_BUYINGS_MENU = 'UPDATE_GROUP_BUYINGS_MENU';
